document.documentElement.classList.remove('no-js');

window.dataLayer = window.dataLayer || [];
const rootPath = window.Shopify?.routes?.root || '/';
const liveRegion = document.querySelector('[data-live-region]');

const track = (event, properties = {}) => {
  window.dataLayer.push({ event, ...properties });
};

const announce = (message) => {
  if (!liveRegion) return;
  liveRegion.textContent = '';
  window.setTimeout(() => { liveRegion.textContent = message; }, 30);
};

const updateCartCount = async () => {
  const response = await fetch(`${rootPath}cart.js`, { headers: { Accept: 'application/json' } });
  if (!response.ok) return;
  const cart = await response.json();
  document.querySelectorAll('[data-cart-count]').forEach((element) => { element.textContent = cart.item_count; });
};

const applyCartDiscount = async (discountCode) => {
  if (!discountCode) return null;
  const response = await fetch(`${rootPath}cart/update.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ discount: discountCode })
  });
  const cart = await response.json();
  if (!response.ok) throw new Error(cart.description || 'The offer could not be applied.');
  return cart;
};

const discountCartUrl = (discountCode) => `${rootPath}cart?discount=${encodeURIComponent(discountCode)}`;

const menuButton = document.querySelector('[data-menu-toggle]');
const navigation = document.querySelector('[data-primary-navigation]');
const navDropdowns = [...document.querySelectorAll('[data-nav-dropdown]')];
const closeNavDropdowns = () => navDropdowns.forEach((dropdown) => dropdown.removeAttribute('open'));
navDropdowns.forEach((dropdown) => dropdown.querySelector('summary')?.addEventListener('click', () => {
  if (dropdown.open) return;
  navDropdowns.forEach((otherDropdown) => { if (otherDropdown !== dropdown) otherDropdown.removeAttribute('open'); });
}));
const closeMenu = () => {
  if (!menuButton || !navigation) return;
  menuButton.setAttribute('aria-expanded', 'false');
  navigation.classList.remove('is-open');
  document.body.classList.remove('menu-open');
  closeNavDropdowns();
};

menuButton?.addEventListener('click', () => {
  const open = menuButton.getAttribute('aria-expanded') !== 'true';
  menuButton.setAttribute('aria-expanded', String(open));
  navigation?.classList.toggle('is-open', open);
  document.body.classList.toggle('menu-open', open);
  if (open) navigation?.querySelector('a')?.focus();
});

document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') { closeMenu(); closeNavDropdowns(); }
});

document.addEventListener('click', (event) => { if (!event.target.closest('[data-nav-dropdown]')) closeNavDropdowns(); });

navigation?.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));

if ('IntersectionObserver' in window) {
  const sectionObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      track('heft_section_view', { section_name: entry.target.dataset.heftSection });
      observer.unobserve(entry.target);
    });
  }, { threshold: 0.25 });
  document.querySelectorAll('[data-heft-section]').forEach((section) => sectionObserver.observe(section));
}

const productRoot = document.querySelector('[data-product-root]');
if (productRoot) {
  track('view_item', { item_id: productRoot.dataset.productHandle, item_name: productRoot.dataset.productTitle });
}

const productList = document.querySelector('[data-product-list], .product-grid--featured');
if (productList) {
  track('view_item_list', { item_list_name: productList.matches('.product-grid--featured') ? 'homepage_featured' : 'collection' });
}

document.addEventListener('click', (event) => {
  const productLink = event.target.closest('[data-analytics="select-item"]');
  if (productLink) {
    const card = productLink.closest('[data-product-card]');
    track('select_item', { item_id: card?.dataset.productHandle || '' });
  }

  const quantityButton = event.target.closest('[data-quantity-change]');
  if (quantityButton) {
    const input = quantityButton.parentElement?.querySelector('input[type="number"]');
    if (!input) return;
    const nextValue = Math.max(Number(input.min || 1), Number(input.value || 1) + Number(quantityButton.dataset.quantityChange));
    input.value = String(nextValue);
  }

  const stickyAdd = event.target.closest('[data-sticky-add]');
  if (stickyAdd) {
    track('sticky_atc_click', { item_id: productRoot?.dataset.productHandle || '' });
    document.querySelector('[data-heft-product-form]')?.requestSubmit();
  }
});

document.querySelectorAll('[data-variant-select]').forEach((select) => {
  select.addEventListener('change', () => {
    const price = select.selectedOptions[0]?.dataset.price;
    document.querySelectorAll('[data-product-price], [data-mobile-price]').forEach((element) => { if (price) element.textContent = price; });
  });
});

document.querySelectorAll('[data-pdp-gallery]').forEach((gallery) => {
  const viewport = gallery.querySelector('[data-pdp-gallery-viewport]');
  const slides = [...gallery.querySelectorAll('[data-pdp-gallery-slide]')];
  const thumbs = [...gallery.querySelectorAll('[data-pdp-gallery-thumb]')];
  if (!viewport || slides.length < 2 || thumbs.length < 2) return;

  const setActive = (index) => {
    thumbs.forEach((thumb, thumbIndex) => {
      const active = thumbIndex === index;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-current', String(active));
    });
  };

  thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => {
    slides[index]?.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'nearest',
      inline: 'start'
    });
    setActive(index);
    track('product_media_select', { item_id: productRoot?.dataset.productHandle || '', media_position: index + 1 });
  }));

  let galleryFrame;
  viewport.addEventListener('scroll', () => {
    window.cancelAnimationFrame(galleryFrame);
    galleryFrame = window.requestAnimationFrame(() => {
      const index = Math.max(0, Math.min(slides.length - 1, Math.round(viewport.scrollLeft / viewport.clientWidth)));
      setActive(index);
    });
  }, { passive: true });
});

document.querySelectorAll('[data-heft-product-form]').forEach((form) => {
  const packOptions = [...form.querySelectorAll('[data-product-pack]')];
  const purchaseOptions = [...form.querySelectorAll('[data-purchase-option]')];
  const sellingPlanInput = form.querySelector('[data-selling-plan-input]');
  const quantityInput = form.querySelector('[data-product-quantity]');
  const packFieldset = form.querySelector('[data-product-pack-options]');
  const updateDisplayedPrice = (price) => document.querySelectorAll('[data-product-price], [data-mobile-price]').forEach((element) => { if (price) element.textContent = price; });

  const selectPack = (option) => {
    if (!option || !quantityInput) return;
    quantityInput.value = option.dataset.quantity || '1';
    form.dataset.discountCode = option.dataset.discountCode || '';
    updateDisplayedPrice(option.dataset.price);
    track('product_pack_select', { item_id: form.dataset.productHandle, quantity: Number(quantityInput.value), discount_code: form.dataset.discountCode });
  };

  packOptions.forEach((option) => option.addEventListener('change', () => selectPack(option)));
  purchaseOptions.forEach((option) => option.addEventListener('change', () => {
    const isSubscription = option.value === 'subscription';
    if (sellingPlanInput) {
      sellingPlanInput.disabled = !isSubscription;
      sellingPlanInput.value = isSubscription ? option.dataset.sellingPlanId || '' : '';
    }
    if (packFieldset) {
      packFieldset.disabled = isSubscription;
      packFieldset.classList.toggle('is-disabled', isSubscription);
    }
    if (isSubscription) {
      if (quantityInput) quantityInput.value = '1';
      form.dataset.discountCode = '';
      updateDisplayedPrice(option.dataset.planPrice);
    } else {
      selectPack(packOptions.find((pack) => pack.checked) || packOptions[0]);
    }
    track('purchase_option_select', { item_id: form.dataset.productHandle, purchase_type: isSubscription ? 'subscription' : 'one_time' });
  }));
});

document.querySelectorAll('[data-card-product-form]').forEach((form) => {
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = form.querySelector('[data-card-add-button]');
    const originalLabel = button?.textContent;
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }
    try {
      const response = await fetch(`${rootPath}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'This item could not be added.');
      await updateCartCount();
      announce('Added to your cart.');
      const discountCode = form.dataset.discountCode || '';
      track('add_to_cart', { item_id: form.dataset.productHandle, quantity: 1, source: 'homepage_starter', discount_code: discountCode });
      if (button) button.textContent = 'Added';
      if (discountCode) {
        await applyCartDiscount(discountCode);
        window.location.assign(discountCartUrl(discountCode));
      }
    } catch (error) {
      announce(error.message);
      if (button) button.textContent = 'Try again';
    } finally {
      window.setTimeout(() => { if (button) { button.disabled = false; button.textContent = originalLabel; } }, 900);
    }
  });
});

document.querySelectorAll('[data-heft-product-form]').forEach((form) => {
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = form.querySelector('[data-add-button]');
    const message = form.querySelector('[data-product-message]');
    const originalLabel = button?.textContent;
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }
    try {
      const response = await fetch(`${rootPath}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'This item could not be added.');
      await updateCartCount();
      if (message) message.textContent = 'Added to your cart.';
      announce(`${productRoot?.dataset.productTitle || 'Product'} added to cart.`);
      const formData = new FormData(form);
      const discountCode = form.dataset.discountCode || '';
      track('add_to_cart', { item_id: form.dataset.productHandle, quantity: Number(formData.get('quantity') || 1), purchase_type: formData.get('selling_plan') ? 'subscription' : 'one_time', discount_code: discountCode });
      if (discountCode && !formData.get('selling_plan')) {
        await applyCartDiscount(discountCode);
        window.location.assign(discountCartUrl(discountCode));
      }
    } catch (error) {
      if (message) message.textContent = error.message;
      announce(error.message);
    } finally {
      if (button) { button.disabled = false; button.textContent = originalLabel; }
    }
  });
});

document.querySelectorAll('[data-bundle-add]').forEach((button) => {
  button.addEventListener('click', async () => {
    const message = button.parentElement?.querySelector('[data-bundle-message]');
    const ids = (button.dataset.variantIds || '').split(',').filter(Boolean);
    const discountCode = button.dataset.discountCode || '';
    if (ids.length < 2) return;
    const originalLabel = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';
    try {
      const response = await fetch(`${rootPath}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: ids.map((id) => ({ id: Number(id), quantity: 1 })) })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'This bundle could not be added.');
      await updateCartCount();
      if (message) message.textContent = 'The full bundle is in your cart.';
      announce(`${button.dataset.bundleTitle || 'Bundle'} added to cart.`);
      track('add_bundle_to_cart', { bundle_name: button.dataset.bundleTitle || '', item_count: ids.length, discount_code: discountCode });
      if (discountCode) {
        await applyCartDiscount(discountCode);
        window.location.assign(discountCartUrl(discountCode));
      }
    } catch (error) {
      if (message) message.textContent = error.message;
      announce(error.message);
    } finally {
      button.disabled = false;
      button.textContent = originalLabel;
    }
  });
});

document.querySelectorAll('[data-bundle-builder]').forEach((builder) => {
  const rows = [...builder.querySelectorAll('[data-builder-row]')];
  const quantities = [...builder.querySelectorAll('[data-builder-quantity]')];
  const sizeChoices = [...builder.querySelectorAll('[data-builder-size]')];
  const addButton = builder.querySelector('[data-builder-add]');
  const count = builder.querySelector('[data-builder-count]');
  const message = builder.querySelector('[data-builder-message]');
  const price = builder.querySelector('[data-builder-price]');
  const priceNote = builder.querySelector('[data-builder-price-note]');

  const selectedTier = () => sizeChoices.find((choice) => choice.checked) || sizeChoices[0];
  const quantityTotal = () => quantities.reduce((total, input) => total + Number(input.value || 0), 0);
  const normaliseQuantity = (input) => {
    const tier = selectedTier();
    const target = Number(tier?.value || 3);
    const mode = tier?.dataset.selectionMode || 'exact';
    const others = quantities.reduce((total, candidate) => candidate === input ? total : total + Number(candidate.value || 0), 0);
    const maximum = mode === 'exact' ? Math.max(0, target - others) : 99;
    input.value = String(Math.min(maximum, Math.max(0, Math.floor(Number(input.value) || 0))));
  };

  const refresh = ({ reset = false } = {}) => {
    const tier = selectedTier();
    const selectedSize = Number(tier?.value || builder.dataset.selectedSize || 3);
    const selectionMode = tier?.dataset.selectionMode || 'exact';
    const fixedPriceCents = Number(tier?.dataset.fixedPriceCents || 0);
    const unitPriceCents = Number(tier?.dataset.unitPriceCents || 0);
    builder.dataset.minimum = String(selectedSize);
    builder.dataset.maximum = selectionMode === 'minimum' ? '' : String(selectedSize);
    builder.dataset.selectedSize = String(selectedSize);
    builder.dataset.selectionMode = selectionMode;
    if (reset) quantities.forEach((input) => { input.value = '0'; });
    const total = quantityTotal();
    const valid = selectionMode === 'minimum' ? total >= selectedSize : total === selectedSize;
    const formatPrice = (cents) => `$${(cents / 100).toFixed(2)}`;
    const formatUnitPrice = (cents) => cents % 100 === 0 ? `$${cents / 100}` : formatPrice(cents);
    const calculatedPriceCents = unitPriceCents ? total * unitPriceCents : fixedPriceCents;
    rows.forEach((row) => {
      const input = row.querySelector('[data-builder-quantity]');
      const rowQuantity = Number(input?.value || 0);
      row.classList.toggle('has-quantity', rowQuantity > 0);
      row.querySelector('[data-builder-decrease]')?.toggleAttribute('disabled', rowQuantity === 0);
      row.querySelector('[data-builder-increase]')?.toggleAttribute('disabled', selectionMode === 'exact' && total >= selectedSize);
    });
    if (addButton) {
      const buttonPrice = unitPriceCents && !valid ? `${formatUnitPrice(unitPriceCents)} each` : formatPrice(calculatedPriceCents);
      addButton.disabled = !valid;
      addButton.textContent = selectionMode === 'minimum' ? `Add ${valid ? total : selectedSize}+ items · ${buttonPrice}` : `Add ${selectedSize} items · ${buttonPrice}`;
    }
    if (count) {
      count.textContent = selectionMode === 'minimum'
        ? total >= selectedSize ? `${total} items selected · minimum reached` : `${total} of ${selectedSize} minimum selected`
        : `${total} of ${selectedSize} items selected`;
    }
    if (price) price.textContent = unitPriceCents && !valid ? `${formatUnitPrice(unitPriceCents)} each` : formatPrice(calculatedPriceCents);
    if (priceNote) priceNote.textContent = unitPriceCents ? valid ? `${total} items at ${formatUnitPrice(unitPriceCents)} each` : `${selectedSize}-item minimum` : `${selectedSize} items`;
  };

  rows.forEach((row) => {
    const input = row.querySelector('[data-builder-quantity]');
    row.querySelector('[data-builder-decrease]')?.addEventListener('click', () => {
      input.value = String(Math.max(0, Number(input.value || 0) - 1));
      refresh();
    });
    row.querySelector('[data-builder-increase]')?.addEventListener('click', () => {
      input.value = String(Number(input.value || 0) + 1);
      normaliseQuantity(input);
      refresh();
    });
    input?.addEventListener('input', () => {
      normaliseQuantity(input);
      refresh();
    });
  });
  sizeChoices.forEach((choice) => choice.addEventListener('change', () => {
    refresh({ reset: true });
    track('bundle_size_select', { bundle_size: Number(choice.value), source: 'bundle_builder' });
  }));
  addButton?.addEventListener('click', async () => {
    const selected = quantities
      .map((input) => ({ id: Number(input.dataset.variantId), quantity: Number(input.value || 0) }))
      .filter((item) => item.id && item.quantity > 0);
    const selectedSize = Number(builder.dataset.selectedSize || 3);
    const selectionMode = builder.dataset.selectionMode || 'exact';
    const tier = selectedTier();
    const fixedPriceCents = Number(tier?.dataset.fixedPriceCents || 0);
    const unitPriceCents = Number(tier?.dataset.unitPriceCents || 0);
    const discountCode = tier?.dataset.discountCode || '';
    const total = selected.reduce((sum, item) => sum + item.quantity, 0);
    if (selectionMode === 'minimum' ? total < selectedSize : total !== selectedSize) return;
    addButton.disabled = true;
    addButton.textContent = 'Adding…';
    try {
      const response = await fetch(`${rootPath}cart/add.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: selected })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'These formulas could not be added.');
      await updateCartCount();
      if (message) message.textContent = 'Your selected formulas are in the cart.';
      announce('Selected HEFT formulas added to cart.');
      const bundleValue = (unitPriceCents ? total * unitPriceCents : fixedPriceCents) / 100;
      track('add_custom_bundle_to_cart', { bundle_size: selectedSize, item_count: total, variant_count: selected.length, bundle_value: bundleValue, discount_code: discountCode });
      if (discountCode) {
        await applyCartDiscount(discountCode);
        window.location.assign(discountCartUrl(discountCode));
      }
    } catch (error) {
      if (message) message.textContent = error.message;
      announce(error.message);
    } finally {
      refresh();
    }
  });
  refresh();
});

document.querySelectorAll('[data-bundle-size-jump]').forEach((link) => {
  link.addEventListener('click', () => {
    const builder = document.querySelector('[data-bundle-builder]');
    const size = Number(link.dataset.bundleSizeJump || 3);
    const radio = builder?.querySelector(`[data-builder-size][value="${size}"]`);
    if (!builder || !radio) return;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
    track('bundle_size_select', { bundle_size: size, source: 'bundle_category' });
  });
});

const mainPurchaseButton = document.querySelector('[data-add-button]');
const mobilePurchase = document.querySelector('[data-mobile-purchase]');
if (mainPurchaseButton && mobilePurchase && 'IntersectionObserver' in window) {
  const purchaseObserver = new IntersectionObserver(([entry]) => {
    mobilePurchase.classList.toggle('is-visible', !entry.isIntersecting);
  }, { threshold: 0 });
  purchaseObserver.observe(mainPurchaseButton);
}

document.querySelector('[data-sort-select]')?.addEventListener('change', (event) => event.target.form?.submit());

document.querySelectorAll('[data-heft-capture]').forEach((form) => {
  let intentTracked = false;
  form.querySelector('input[type="email"]')?.addEventListener('focus', () => {
    if (intentTracked) return;
    intentTracked = true;
    track('newsletter_signup_intent', { capture_location: form.dataset.captureLocation || 'unknown' });
  });
  form.addEventListener('submit', () => track('newsletter_signup_submit', { capture_location: form.dataset.captureLocation || 'unknown' }));
});

document.querySelector('[data-search-form]')?.addEventListener('submit', (event) => {
  const query = new FormData(event.target).get('q');
  track('search', { search_term_length: String(query || '').length });
});

document.querySelectorAll('details').forEach((details) => {
  details.addEventListener('toggle', () => {
    if (details.open) track('content_detail_open', { detail_name: details.querySelector('summary')?.textContent.trim() || '' });
  });
});

const initGarden = (garden) => {
  if (garden.dataset.gardenInitialized === 'true') return;
  garden.dataset.gardenInitialized = 'true';
  const dialog = garden.querySelector('[data-garden-dialog]');
  const dialogTitle = dialog?.querySelector('[data-garden-dialog-title]');
  const dialogFamily = dialog?.querySelector('[data-garden-dialog-family]');
  const dialogDescription = dialog?.querySelector('[data-garden-dialog-description]');
  const dialogIndex = dialog?.querySelector('[data-garden-dialog-index]');
  const dialogImage = dialog?.querySelector('[data-garden-dialog-image]');
  const dialogLink = dialog?.querySelector('[data-garden-dialog-link]');
  const dialogStatus = dialog?.querySelector('[data-garden-dialog-status]');
  let lastTrigger = null;
  let viewTracked = false;

  const trackGardenView = () => {
    if (viewTracked) return;
    viewTracked = true;
    track('garden_view', { product_count: 14 });
  };

  if ('IntersectionObserver' in window) {
    const gardenObserver = new IntersectionObserver(([entry], observer) => {
      if (!entry.isIntersecting) return;
      trackGardenView();
      observer.disconnect();
    }, { threshold: 0.15 });
    gardenObserver.observe(garden);
  } else {
    trackGardenView();
  }

  const finishClose = () => {
    document.body.classList.remove('garden-dialog-open');
    lastTrigger?.focus();
  };

  const closeDialog = () => {
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
    else {
      dialog.removeAttribute('open');
      finishClose();
    }
  };

  garden.querySelectorAll('[data-garden-trigger]').forEach((trigger) => {
    trigger.addEventListener('click', () => {
      if (!dialog || !dialogTitle || !dialogFamily || !dialogDescription || !dialogLink) return;
      lastTrigger = trigger;
      const computedStyle = getComputedStyle(trigger);
      ['--product-ink', '--product-accent', '--product-wash'].forEach((property) => {
        dialog.style.setProperty(property, computedStyle.getPropertyValue(property));
      });
      dialogTitle.textContent = trigger.dataset.productName || '';
      dialogFamily.textContent = trigger.dataset.productFamily || '';
      dialogDescription.textContent = trigger.dataset.productDescription || '';
      if (dialogImage) {
        dialogImage.src = trigger.dataset.productImageSmall || '';
        dialogImage.srcset = `${trigger.dataset.productImageSmall || ''} 640w, ${trigger.dataset.productImageLarge || ''} 1280w`;
      }
      const productAvailable = trigger.dataset.productAvailable === 'true' && Boolean(trigger.dataset.productUrl);
      dialogLink.hidden = !productAvailable;
      if (productAvailable) dialogLink.href = trigger.dataset.productUrl;
      else dialogLink.removeAttribute('href');
      if (dialogStatus) dialogStatus.hidden = productAvailable;
      dialogLink.dataset.productHandle = trigger.dataset.productHandle || '';
      dialogLink.dataset.productName = trigger.dataset.productName || '';
      track('garden_product_select', {
        item_id: trigger.dataset.productHandle || '',
        item_name: trigger.dataset.productName || '',
        garden_surface: trigger.dataset.gardenSurface || 'unknown'
      });
      document.body.classList.add('garden-dialog-open');
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else {
        dialog.setAttribute('open', '');
        dialog.setAttribute('aria-modal', 'true');
      }
      dialog.querySelector('[data-garden-close]')?.focus();
    });
  });

  dialog?.querySelector('[data-garden-close]')?.addEventListener('click', closeDialog);
  dialog?.addEventListener('cancel', (event) => {
    event.preventDefault();
    closeDialog();
  });
  dialog?.addEventListener('close', finishClose);
  dialog?.addEventListener('click', (event) => {
    if (event.target === dialog) closeDialog();
  });
  dialog?.addEventListener('keydown', (event) => {
    if (event.key !== 'Tab') return;
    const focusable = [...dialog.querySelectorAll('a[href], button:not([disabled])')];
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });
  dialogLink?.addEventListener('click', () => {
    if (dialogLink.hidden || !dialogLink.hasAttribute('href')) return;
    track('garden_product_view', {
      item_id: dialogLink.dataset.productHandle || '',
      item_name: dialogLink.dataset.productName || '',
      source: 'garden_preview'
    });
  });
};

document.querySelectorAll('[data-garden-root]').forEach(initGarden);

const initArtDirection = (scope = document) => {
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const chapters = scope.matches?.('[data-heft-section]') ? [scope] : [...scope.querySelectorAll?.('[data-heft-section]') || []];
  const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
    if (!entry.isIntersecting) return;
    entry.target.classList.add('is-revealed');
    observer.unobserve(entry.target);
  }), { threshold: 0.08, rootMargin: '0px 0px -7% 0px' });
  chapters.forEach((chapter) => {
    chapter.classList.add('chapter-reveal');
    observer.observe(chapter);
  });
};

initArtDirection();
document.addEventListener('shopify:section:load', (event) => {
  if (event.target.matches?.('[data-garden-root]')) initGarden(event.target);
  event.target.querySelectorAll?.('[data-garden-root]').forEach(initGarden);
  initArtDirection(event.target);
});
